import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=de0b01d2"
import script from "./AboutComponent.vue?vue&type=script&lang=ts"
export * from "./AboutComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports